import Fetch from 'Util/fetcher';
import { errorLogger } from '@ajaibid/utils';
import { DEFAULT_POST_RESPONSE } from '@config/constanta';
import { dtPostOrderUrl } from './_endpoint';

const fetchPost = (resourceUrl, payload) =>
  Fetch.post(resourceUrl, payload)
    .then((resp) => resp.json)
    .catch((error) => {
      errorLogger('ERROR_API', error.message, { path: resourceUrl });
      return { ...DEFAULT_POST_RESPONSE, err_message: error.message };
    });

// DT Limit order
export const postDtBuy = (payload = {}) => fetchPost(dtPostOrderUrl('buy'), payload);
export const postDtSell = (payload = {}) => fetchPost(dtPostOrderUrl('sell'), payload);
export const postDtAmend = (payload = {}) => fetchPost(dtPostOrderUrl('amend'), payload);
export const postDtWithdraw = (payload = {}) => fetchPost(dtPostOrderUrl('withdraw'), payload);
